<template>
  <div class="backgroundImg"></div>
  <div class="floatdiv">
    <h1 class="titulo">
      Bem Vindo ao Curso Técnico em Informática da Escola Estadual Silva Paes!
    </h1>
    <p class="justificado">
      Aqui você conhecerá um pouco sobre o desenvolvimento do curso Técnico em
      Informática Integrado ao Ensino Médio dentro da escola, com uma breve
      apresentação dos conteúdos abordados durante o período do curso e as
      principais atividades extra curriculares realizadas durante esta
      trajetória. Além disso, você também poderá acompanhar através de muitas
      fotos e comentários de ex-alunos e alunos que ainda estão a concluir ao
      curso de técnico.
    </p>
    <div class="logos">
      <img class="logo" src="../assets/images/brasao_2.png" alt="sla" />
    </div>
  </div>
</template>


<style lang="scss" scoped>
.logos {
  display: flex;
  justify-content: center;
  align-items: center;
  .logo {
    display: block;
    width: 180px;
    height: auto;
    padding-top: 20px;
    margin: 50px 0;
  }
}
</style>
